import { motion, AnimatePresence } from "framer-motion";
import { BALLOON_FLEET } from "@/lib/mapConstants";

// 🎈 BALLOON FEST — festival balloons drift up the map every October.
export const BalloonFestOverlay = ({ active }) => (
  <AnimatePresence>
    {active && (
      <>
        <motion.div
          data-testid="balloonfest-banner"
          initial={{ opacity: 0, y: -20, scale: 0.8 }} animate={{ opacity: 1, y: [0, -3, 0], scale: 1 }} exit={{ opacity: 0, scale: 0.8 }}
          transition={{ y: { duration: 0.5, repeat: 10, repeatType: "mirror", ease: "easeInOut" } }}
          className="absolute top-24 sm:top-28 left-1/2 -translate-x-1/2 z-[1850] glass-strong border border-sky-400/40 rounded-full px-5 py-2 shadow-2xl pointer-events-none"
        >
          <span className="font-heading font-extrabold text-base sm:text-lg bg-gradient-to-r from-sky-400 via-fuchsia-400 to-amber-400 bg-clip-text text-transparent tracking-tight">🎈 AIR.POG BALLOON FEST! 🎈</span>
        </motion.div>
        {BALLOON_FLEET.map((b, i) => (
          <motion.img
            key={i}
            data-testid={i === 0 ? "balloonfest-balloon" : `balloon-${i}`}
            src={b.img}
            alt=""
            initial={{ y: "30vh", opacity: 0 }}
            animate={{ y: "-115vh", opacity: 1, x: [0, b.sway, -b.sway, b.sway * 0.6, 0], rotate: [0, 3, -3, 2, 0] }}
            exit={{ opacity: 0 }}
            transition={{
              y: { duration: b.dur, ease: "linear", delay: b.delay },
              opacity: { duration: 0.5, delay: b.delay },
              x: { duration: b.dur, ease: "easeInOut", delay: b.delay },
              rotate: { duration: b.dur, ease: "easeInOut", delay: b.delay },
            }}
            className="absolute bottom-0 z-[1840] h-auto object-contain rounded-2xl drop-shadow-[0_0_22px_rgba(56,189,248,0.45)] pointer-events-none select-none"
            style={{ width: b.w, left: b.left }}
          />
        ))}
      </>
    )}
  </AnimatePresence>
);
